import hand from './../../../images/HAND.jpg'
export const DATAS=[
    {
        id:1,
        name:"wali",
        profilePicture:hand,
    },

    {
        id:2,
        name:"wali",
        profilePicture:hand,
    },
    {
        id:3,
        name:" Ali",
        profilePicture:hand,
    },
    {
        id:4,
        name:"wali",
        profilePicture:hand,
    },

]